export default "__VITE_ASSET__kmW53132__"